import { useEffect } from "react";
import { ArrowLeft } from "lucide-react";
import { useLang } from "../../i18n";

export default function LegalShell({ title, children, testid }) {
  const { t } = useLang();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-[#F8F9FA]" data-testid={testid}>
      <header className="border-b border-[#9B7AE8]/15 bg-white/75 backdrop-blur-xl">
        <div className="mx-auto flex h-[72px] max-w-4xl items-center justify-between px-5 sm:px-8">
          <a href="/" data-testid="legal-logo-link" aria-label={t.legal.home}>
            <img src="/assets/logo.png" alt="Shake & Shake" className="h-9 w-auto" />
          </a>
          <a
            href="/"
            data-testid="legal-back-link"
            className="font-nav flex items-center gap-2 text-[11px] font-semibold uppercase tracking-[0.2em] text-[#6B6386] transition-colors hover:text-[#9B7AE8]"
          >
            <ArrowLeft size={14} strokeWidth={2.5} />
            {t.legal.home}
          </a>
        </div>
      </header>
      <main className="mx-auto max-w-4xl px-5 py-20 sm:px-8">
        <h1 className="font-display text-3xl font-bold tracking-tight text-[#221A3D] sm:text-4xl">{title}</h1>
        <div className="mt-12">{children}</div>
      </main>
      <footer className="border-t border-[#9B7AE8]/10 px-5 py-8 text-center text-xs text-[#8E85AC] sm:px-8">
        {t.footer.copyright}
      </footer>
    </div>
  );
}
